<template>
    <div class="layout-footer">
        <span class="inline text-muted-color">COPYRIGHT © {{ new Date().getFullYear() }}
            <router-link :to="{ name: 'dashboard' }">
                IMPRION ADMIN WORK LOG</router-link>, All rights Reserved
        </span>
    </div>
</template>

<script setup lang="ts">
</script>
